import { AUSTRALIA_UI_MESSAGES, AUSTRALIA_UI_TEXT_REPLACEMENTS } from '../templates/australia/locales/en-AU.js'

export function isAustraliaEnglishCopy(templateKey, locale) {
  return templateKey === 'australia' && /^en(?:[-_]|$)/i.test(String(locale || ''))
}

const formErrors = {
  Username: 'Enter your username.',
  'Email address': 'Enter your email address.',
  Password: 'Enter your password.',
  'Confirm password': 'Confirm your password.',
  'LINE ID': 'Enter your LINE ID.',
  'Code shown in the image': 'Enter the code shown in the image.',
  'Username or email address': 'Enter your username or email address.',
}
const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function getAustraliaUiMessage(key, params = {}) {
  params = params && typeof params === 'object' ? params : { count: params }
  if (key === 'placeholder.pleaseEnter{text}' || key === 'placeholder.pleaseSelected{text}') {
    const label = String(params.text || '').toLowerCase()
    return Object.entries(formErrors).find(([field]) => field.toLowerCase() === label)?.[1] ?? null
  }
  if (key === 'texts.monthDay') {
    const month = Number(params.month), day = Number(params.day)
    return Number.isInteger(month) && month >= 1 && month <= 12 && Number.isInteger(day) && day >= 1 && day <= 31
      ? `${day} ${months[month - 1]}` : null
  }
  let message = AUSTRALIA_UI_MESSAGES[key]
  if (!message) return null
  if (typeof message === 'object') message = Number(params.count ?? params.num) === 1 ? message.one : message.other
  return message.replace(/\{(\w+)\}/g, (match, name) => params[name] == null ? match : String(params[name]))
}

export function translateStorefrontUi(key, params, context, fallback) {
  if (!isAustraliaEnglishCopy(context.templateKey, context.locale)) return fallback()
  return getAustraliaUiMessage(key, params) ?? fallback()
}

export function translateAustraliaTemplateText(value, templateKey, locale) {
  if (!isAustraliaEnglishCopy(templateKey, locale) || typeof value !== 'string') return value
  return AUSTRALIA_UI_TEXT_REPLACEMENTS[value] ?? value
}
